import { inject, Injectable, signal } from '@angular/core';
import { Toast } from '@mwe/models';
import { NavigationEnd, Router } from '@angular/router';
import { tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private currentToast = signal<Toast>(null);
  private router = inject(Router);

  constructor() {
    this.router.events
      .pipe(
        tap(event => {
          if (event instanceof NavigationEnd) {
            if (!this.currentToast()?.staysVisible) return;
            this.currentToast.set(null);
          }
        }),
      )
      .subscribe();
  }

  get toast() {
    return this.currentToast.asReadonly();
  }

  publishNewToast({ newToast, timeout = 5 * 1000 }: { newToast: Toast; timeout?: number }) {
    this.currentToast.set(newToast);

    if (!this.currentToast().staysVisible) {
      setTimeout(() => {
        this.currentToast.set(null);
      }, timeout);
    }
  }
}
